import TesztlapokDto from 'app/admin/tesztlapok/dto/TesztlapokDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class TesztlapokTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'tesztlapLatticeTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, TesztlapokDto)))
				.catch(reject);
		});
	}
}

export default new TesztlapokTableService();
